import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { apiErrorNotice, type ApiErrorPolicyOptions } from "@/lib/api-error-policy";

interface ApiErrorNoticeProps extends ApiErrorPolicyOptions {
  error: unknown;
  className?: string;
  requestIdClassName?: string;
  "data-testid"?: string;
}

export function ApiErrorNotice({
  error,
  className,
  requestIdClassName,
  "data-testid": testId,
  ...options
}: ApiErrorNoticeProps): React.ReactElement {
  const { t } = useTranslation();
  const notice = apiErrorNotice(error, options);
  return (
    <span className={cn("inline-flex flex-col", className)} data-testid={testId} role="alert">
      <span>{notice.message}</span>
      {notice.requestId ? (
        <span className={cn("text-muted-foreground font-mono text-xs", requestIdClassName)}>
          {t("common.apiError.requestId", { id: notice.requestId })}
        </span>
      ) : null}
    </span>
  );
}
